import { useTranslation } from "react-i18next"
import { BiLogoDevTo } from "react-icons/bi"
import {
  FaBehanceSquare,
  FaLinkedin,
  FaStackOverflow,
  FaYoutube,
} from "react-icons/fa"
import { FaFacebook } from "react-icons/fa6"

import LinkWithIcon from "@/components/LinkWithIcon/LinkWithIcon"
import Loading from "@/components/Loading/Loading"
import { MODALS } from "@/constants/modals"
import { useSocialLinksData } from "@/queries/queries"
import type { ProfileLinks } from "@/types/profileTypes"
import { editIcon } from "@/utils/variables"
import { useStore } from "@/zustand/store"

export default function SocialLinks() {
  const { t } = useTranslation()
  const socialLinksQuery = useSocialLinksData()
  const { editModalState } = useStore()

  const socialMap: Record<ProfileLinksKeys, JSX.Element> = {
    linkedin: <FaLinkedin size={40} color="black" />,
    github: <FaBehanceSquare size={40} color="black" />,
    behance: <FaBehanceSquare size={40} color="black" />,
    facebook: <FaFacebook size={36} color="black" />,
    youtube: <FaYoutube size={40} color="black" />,
    stackoverflow: <FaStackOverflow size={36} color="black" />,
    devto: <BiLogoDevTo size={40} color="black" />,
  }

  if (socialLinksQuery.isLoading) {
    return <Loading />
  }

  return (
    <div className="portolio bg-white">
      <div className="d-flex gap-4 align-items-center justify-content-between mb-4">
        <h3 className="m-0">{t("profilePage.socialLinks.title")}</h3>
        <LinkWithIcon
          icon={editIcon}
          onClick={() => {
            editModalState(
              MODALS.profile.editSocialLinks,
              socialLinksQuery.data || ({} as ProfileLinks)
            )
          }}
          title={t("buttons.edit")}
          color={"#243B78"}
        />
      </div>

      <div className="links d-flex align-items-center gap-3">
        {socialLinksQuery.data &&
          (
            Object.entries(socialMap) as Array<[ProfileLinksKeys, JSX.Element]>
          ).map(([key, icon]) =>
            socialLinksQuery.data[key] ? (
              <a
                key={key}
                href={socialLinksQuery.data[key]}
                target="_blank"
                rel="noopener noreferrer"
              >
                {icon}
              </a>
            ) : null
          )}
      </div>
    </div>
  )
}

type ProfileLinksKeys = keyof Omit<ProfileLinks, "user_id" | "cv_link">
